/* eslint-disable @typescript-eslint/naming-convention */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import experiments from 'experiments/currentExperiments.json';
import { HYDRATE } from 'next-redux-wrapper';
import type { ParsedUrlQuery } from 'querystring';

import type { HydrateAction } from 'redux-store/index';

import getOneLinkParams from 'utils/getOneLinkParams';

import type { ExperimentsStateType, IExperiment } from './types';

const initialState = {
  appleOneLinkUrl: 'https://welltory.onelink.me/yCOv',
  googleOneLinkUrl: 'https://welltory.onelink.me/FLHY',
  experiments: {},
} as ExperimentsStateType;
const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    getExperiments(
      state,
      action: PayloadAction<{
        cookies: Record<string, string>;
        setCookie: string | number | string[] | undefined;
      }>,
    ) {
      const { cookies, setCookie } = action.payload;

      if (Array.isArray(setCookie)) {
        setCookie.forEach(cookieString => {
          const parsedCookie = cookieString.split(';')[0].split('=');

          if (parsedCookie.length > 0) {
            cookies[parsedCookie[0]] = parsedCookie[1];
          }
        });
      }

      const currentExperiments: Record<string, string> = {};

      experiments.forEach((experiment: IExperiment) => {
        const cookie = cookies[experiment.id];

        if (cookie) {
          currentExperiments[experiment.id] = cookie;
        }
      });

      state.experiments = currentExperiments;
    },
    setOneLinkUrl(
      state,
      action: PayloadAction<{
        query: ParsedUrlQuery;
        apple?: string;
        google?: string;
      }>,
    ) {
      const {
        query,
        apple = 'https://welltory.onelink.me/yCOv',
        google = 'https://welltory.onelink.me/FLHY',
      } = action.payload;
      const linkParams = getOneLinkParams(query);
      state.googleOneLinkUrl = `${google}?${linkParams}`;
      state.appleOneLinkUrl = `${apple}?${linkParams}`;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      HYDRATE,
      (state, action: HydrateAction<ExperimentsStateType>) => {
        return action.payload.experiments;
      },
    );
  },
});

export const { getExperiments, setOneLinkUrl } = experimentsSlice.actions;

export default experimentsSlice.reducer;
